import { render, staticRenderFns } from "./BiddingProduct.vue?vue&type=template&id=5c8160c5&scoped=true&"
import script from "./BiddingProduct.vue?vue&type=script&lang=js&"
export * from "./BiddingProduct.vue?vue&type=script&lang=js&"
import style0 from "./BiddingProduct.vue?vue&type=style&index=0&id=5c8160c5&lang=scss&scoped=true&"
import style1 from "./BiddingProduct.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8160c5",
  null
  
)

export default component.exports